export default __webpack_public_path__ + "static/media/hero-video1.5adef674.mp4";